import { useEffect, useState } from "react";
import { readPreference, savePreference } from "../lib/purchaseGuide";
export function usePurchasePreference(key: string): [boolean, (value: boolean) => void] {
  const [value, setValue] = useState(() => readPreference(key));
  useEffect(() => {
    const refresh = () => setValue(readPreference(key));
    window.addEventListener("dwik-preference", refresh);
    window.addEventListener("storage", refresh);
    return () => { window.removeEventListener("dwik-preference", refresh); window.removeEventListener("storage", refresh); };
  }, [key]);
  return [value, next => { savePreference(key, next); setValue(next); }];
}
